import React from 'react';
import { PageHeading, Box } from '@99designs/ui';

import { Layout } from '../Layout';
import { TermsUpdate } from '../TermsUpdate';
import { useTwoFactorUI } from './hooks';
import { VerifyLoginForm } from './VerifyLoginForm';

export function VerifyLogin({ onAuthSuccess }: { onAuthSuccess: (target: string) => void }) {
    const {
        resendRequestCount,
        resendToken,
        verifyToken,
        uiState,
        error,
        showUpdatedTerms,
        postLoginUrl,
    } = useTwoFactorUI(onAuthSuccess);

    if (showUpdatedTerms) {
        return <TermsUpdate redirectUrl={postLoginUrl} onAuthSuccess={onAuthSuccess} />;
    }

    return (
        <Layout title={__('Authenticate')}>
            <Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="baseline"
                    justifyContent="stretch"
                    marginTop="halfGutter"
                    marginBottom="halfGutter"
                >
                    <PageHeading withDivider>
                        {__("We've emailed you a temporary login code to confirm it's really you")}
                    </PageHeading>
                </Box>
                <Box marginBottom="halfGutter" marginTop="halfGutter">
                    {__(
                        "You're almost there. This helps us to keep your account as secure as possible"
                    )}
                </Box>

                <VerifyLoginForm
                    inputError={error}
                    onSubmit={verifyToken}
                    requestNewToken={resendToken}
                    resendRequestCount={resendRequestCount}
                    uiState={uiState}
                />
            </Box>
        </Layout>
    );
}
